import { makeStyles, Typography } from "@material-ui/core";
import React from "react";
import logo from "./../../assets/agencyIQ_Logo.png";

const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: 20,
    width: 700,
    height: 350,
    background: "white",
    display: "flex",
    margin: "auto",
    borderRadius: 10,
    boxShadow:
      "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
  },
  card: {
    marginTop: 10,
    width: "100%",
    height: "auto",
    padding: 20,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  logoContainer: {
    display: "flex",
    justifyContent: "center",
  },
  logo: {
    height: 80,
  },
  content: {
    margin: 10,
    textAlign: "center",
  },
  heading: {
    fontSize: 34,
    fontWeight: "bold",
    color: "#28367B",
    marginBottom: 10,
  },
  subHeading: {
    margin: 10,
    fontSize: 18,
    textAlign: "center",
    lineHeight: 2,
  },
}));

const UnavailableFeature = () => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <div className={classes.card}>
        <div className={classes.logoContainer}>
          <img className={classes.logo} src={logo} alt="AgencyIQ" />
        </div>
        <div className={classes.content}>
          <Typography
            className={classes.heading}
            style={{ fontWeight: 900 }}
          >
            User Access Not Set Up
          </Typography>
          <div className={classes.subHeading}>
            Your agency is onboarded, but your individual user access hasn't
            been configured yet. Please contact your agency principal to
            complete setup via AgencyIQ User Management.
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnavailableFeature;
